import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AuthCard } from '../components/AuthCard';
import { Input } from '../components/Input';
import { Button } from '../components/Button';
export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle login logic here
    console.log('Login with:', email, password);
  };
  return <AuthCard title="Welcome back" subtitle="Please enter your credentials to access your account" data-id="element-66">
      <form onSubmit={handleSubmit} data-id="element-67">
        <Input id="email" label="Email" type="email" placeholder="your@email.com" value={email} onChange={e => setEmail(e.target.value)} required data-id="element-68" />
        <Input id="password" label="Password" type="password" placeholder="••••••••" value={password} onChange={e => setPassword(e.target.value)} required data-id="element-69" />
        <div className="flex justify-end mb-6" data-id="element-70">
          <Link to="/forgot-password" className="text-sm text-primary-500 hover:text-primary-600" data-id="element-71">
            Forgot password?
          </Link>
        </div>
        <Button type="submit" variant="primary" fullWidth data-id="element-72">
          Login
        </Button>
        <div className="mt-6 text-center text-sm text-gray-500" data-id="element-73">
          Don't have an account?{' '}
          <Link to="/signup" className="text-primary-500 hover:text-primary-600 font-medium" data-id="element-74">
            Sign up
          </Link>
        </div>
      </form>
    </AuthCard>;
};